import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { useFieldErrors } from 'shared/domains/forms';
export function ValidationError() {
    const errors = useFieldErrors('document');
    if (!errors.length) {
        return null;
    }
    return (<Alert appearance="warning" message={t({
            message: 'Please select if you want to edit the existing document or create a new copy to edit.',
            comment: 'Form validation message when creating a free-text document',
        })}/>);
}
